/**
 * 字符串插入字符串
 * @param {string} 被插入的字符串
 * @param {number} 插入的位置
 * @param {string} 插入的字符串
 * @returns {string} 新的字符串
 */
export default function insertStr(soure, start, newStr) {
    return soure.slice(0, start) + newStr + soure.slice(start);
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/utils/insertStr.js
// module id = null
// module chunks = 